import React, { useEffect, useState } from 'react'
import { getLocationByToken, updateCandidateLocation } from '../lib/api'

export default function GeoTracker({ token }) {
  const [status, setStatus] = useState('loading')
  const [error, setError] = useState('')
  const [lastSent, setLastSent] = useState(null)
  const [tokenValid, setTokenValid] = useState(false)

  const appLink = `geotracker://geo/${token}`

  useEffect(() => {
    if (!token) { setStatus('invalid'); return }

    getLocationByToken(token).then(loc => {
      if (!loc) { setStatus('invalid'); return }
      setTokenValid(true)
      setStatus('ready')
      startTracking(token)
    }).catch(() => { setStatus('invalid') })

    let wakeLock = null
    async function requestWakeLock() {
      try {
        if ('wakeLock' in navigator) wakeLock = await navigator.wakeLock.request('screen')
      } catch(e) {}
    }
    requestWakeLock()
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') requestWakeLock()
    })
    return () => { if (wakeLock) wakeLock.release() }
  }, [token])

  function startTracking(token) {
    if (!navigator.geolocation) { setStatus('error'); return }

    setStatus('tracking')

    const onError = () => {}

    const send = (pos) => {
      const { latitude, longitude, accuracy } = pos.coords
      updateCandidateLocation(token, latitude, longitude, accuracy)
        .then(() => setLastSent(new Date()))
        .catch(() => {})
    }

    navigator.geolocation.getCurrentPosition(send, onError, {
      enableHighAccuracy: false, maximumAge: 300000, timeout: Infinity,
    })

    const watchId = navigator.geolocation.watchPosition(send, onError, {
      enableHighAccuracy: false, maximumAge: 300000, timeout: Infinity,
    })

    const timerId = setInterval(() => {
      navigator.geolocation.getCurrentPosition(send, onError, {
        enableHighAccuracy: false, maximumAge: 300000, timeout: Infinity,
      })
    }, 30000)

    return () => {
      navigator.geolocation.clearWatch(watchId)
      clearInterval(timerId)
    }
  }

  const isTracking = status === 'tracking'

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      background: '#f0f4f8', fontFamily: 'sans-serif', padding: 24
    }}>
      <div style={{
        background: '#fff', borderRadius: 16, padding: 32,
        maxWidth: 360, width: '100%', textAlign: 'center',
        boxShadow: '0 4px 24px rgba(0,0,0,0.10)'
      }}>
        <div style={{ fontSize: 48, marginBottom: 16 }}>
          {isTracking ? '📍' : status === 'invalid' ? '❌' : status === 'error' ? '⚠️' : '⏳'}
        </div>
        <h2 style={{ margin: '0 0 8px', color: '#1a2332' }}>
          {isTracking && 'Location is active'}
          {status === 'loading' && 'Loading...'}
          {status === 'ready' && 'Starting...'}
          {status === 'invalid' && 'Invalid link'}
          {status === 'error' && 'Error'}
        </h2>

        {isTracking && (
          <p style={{ color: '#64748b', fontSize: 14, margin: '8px 0 16px' }}>
            Your location is being shared with the coordinator.<br />
            Please keep this page open.
            {lastSent && (
              <span style={{ display: 'block', marginTop: 8, color: '#94a3b8', fontSize: 12 }}>
                Last update: {lastSent.toLocaleTimeString()}
              </span>
            )}
          </p>
        )}

        {/* Кнопка открытия в приложении */}
        {tokenValid && (
          <a
            href={appLink}
            style={{
              display: 'block', marginTop: 16, padding: '12px 0',
              borderRadius: 10, background: '#378ADD', color: 'white',
              fontSize: 15, fontWeight: 600, textDecoration: 'none',
            }}
          >
            📱 Open in Tracker App
          </a>
        )}

        {error && <p style={{ color: '#ef4444', fontSize: 14, marginTop: 12 }}>{error}</p>}
        {status === 'invalid' && (
          <p style={{ color: '#64748b', fontSize: 14 }}>This link is invalid or has expired.</p>
        )}
      </div>
    </div>
  )
}
